/**
 * @param {string} constraint
 * @returns {int|null}
 */
export default function parseConstraint(constraint) {
    switch (constraint) {
        case 'RefineProcedure':
            return 0;

        case 'Pediatric':
            return 1;

        case 'UrgentCare':
            return 2;

        case 'Obgyn':
            return 3;

        case 'Crosslisted':
            return 4;

        case 'Assistant':
            return 5;

        case 'Naturopath':
            return 6;

        case 'AdditionalCopay':
            return 7;

        default:
            return null;
    }
}
